module.exports = __webpack_public_path__ + "img/preguntas.b60f149b.png";